import { useRBAC, extractPermissionData } from '../../../utils/rbacHandler';

export interface PermissionData {
  canEdit: boolean;
  canRead: boolean;
  admin: boolean;
  roles: string[];
}

export interface PermissionChecks {
  canEdit: boolean;
  canRead: boolean;
  canView: boolean;
  isAdmin: boolean;
  hasViewerRole: boolean;
  hasEditorRole: boolean;
  canAddItems: boolean;
  canEditItems: boolean;
  canDeleteItems: boolean;
  canManageContacts: boolean;
  canEditOverview: boolean;
  canEditDecisions: boolean;
  canEditAdditionalInfo: boolean;
  canEditMilestones: boolean;
  canEditGeneralInfo: boolean;
}

/**
 * Hook to manage RBAC permissions for the slideout panel
 * @param permissionData - The permission data from the API response
 * @returns Object with permission checks for various actions
 */
export const usePermissions = (
  permissionData?: PermissionData | null
): PermissionChecks => {
  // Use the common RBAC handler
  return useRBAC(permissionData);
};
